module.exports = __webpack_public_path__ + "img/jtgensui.082052e8.gif";